function Mozambique({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1704)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M8.64814 22.2607L4.68677 27.3131C7.58202 30.2087 11.5816 31.9999 15.9999 31.9999C22.6143 31.9999 28.2902 27.9856 30.7269 22.2607H8.64814Z" fill="#FFDA44"/>
  <path d="M30.7518 9.79706C28.3287 4.04138 22.6367 0 15.9999 0C11.5816 0 7.58202 1.79119 4.68677 4.68681L8.69364 9.79706H30.7518Z" fill="#496E2D"/>
  <path d="M3.47827 11.7686V20.1743H31.4489C31.8078 18.8436 32 17.4446 32 16.0004C32 14.5353 31.8026 13.1166 31.4337 11.7686H3.47827Z" fill="black"/>
  <path d="M4.68628 4.68652C-1.56209 10.9349 -1.56209 21.0656 4.68628 27.314C7.26834 24.732 9.75165 22.2486 16 16.0003L4.68628 4.68652Z" fill="#A2001D"/>
  <path d="M6.47561 11.8262L7.51154 15.0147H10.8644L8.15204 16.9854L9.18792 20.174L6.47561 18.2034L3.76317 20.174L4.79929 16.9854L2.08691 15.0147H5.43954L6.47561 11.8262Z" fill="#FFDA44"/>
  <path d="M3.44421 16H9.50822V18.7826H3.44421V16Z" fill="#F0F0F0"/>
  <path d="M10.6563 12.81L9.67248 11.8262L6.47573 15.0229L3.27898 11.8262L2.29517 12.81L5.49473 16.0039L2.29517 19.2035L3.27898 20.174L6.47573 16.983L9.67248 20.174L10.6563 19.2035L7.45673 16.0039L10.6563 12.81Z" fill="black"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Mozambique;
